import { DepartmentGetAllAdapter } from '../../../../adapter';

export default async function DepartmentGetAllUseCase(event) {
    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/department/get-all';

    const result = await DepartmentGetAllAdapter(requestUrl, null);
    return result;
}
